<template>
  <div class="">
    <div class="row-width-actions-bar">
      <div class="columns is-min-height-50 is-gapless">
        <div class="column is-self-centered is-padding-left is-padding-right">
          <span class="is-uppercase title is-6">Informations lot : 
            <router-link class="is-underline" :to="{name: 'LotVue', params: {id: lot.pk}}">
              {{lot.ref}}
            </router-link>
          </span>
        </div>

        <div class="column is-narrow is-border-left" v-if="(isAdmin || isSectorManager) && displayButton">
          <router-link :to="{name: 'LotVue', params: {id: lot.pk}}" class="page-header-btn is-small is-square tooltip is-tooltip-left" data-tooltip="Modifier le lot"><span class="icon is-size-4"><i class="fal fa-edit"></i></span></router-link>
        </div>

      </div>
    </div>

    <div class="columns is-gapless is-border-top has-text-black-ter is-padding">
      <div class="column is-padding-right-xsmall">
        <div class="is-margin-bottom-small"><span class="is-uppercase is-size-6 has-text-weight-medium">Caractéristiques du lot</span></div>
        <div class="is-size-6">
          <div v-if="(lot && lot.nature) || (lot && lot.lot_type)">
            <b>Nature et type :</b> <span v-if="lot && lot.nature">{{natureLabel(lot.nature)}}</span><span v-else-if='lot && lot.nature && lot && lot.lot_type'>-</span> <span v-if="lot && lot.lot_type">{{lotTypeLabel(lot.lot_type)}}</span>
          </div>
          <div v-if="lot && lot.surface">
            <b>Surface : </b>{{lot.surface | prettyPrice}} m2
          </div>
          <div v-if="lot && lot.floor">
            <b>Etage :</b> {{lot.floor}}
          </div>
          <div v-if="lot && lot.exposures && lot.exposures.length">
            <b>Orientation</b> {{lot.exposures | exposuresLabel}}
          </div>
        </div>
      </div>

      <div v-if="lot.nature !== 'parking'" class="column is-padding-left-xsmall">
        <div class="is-margin-bottom-small"><span class="is-uppercase is-size-6 has-text-weight-medium">Annexe / Parking</span></div>
        <div class="is-size-6">
          <div v-if="lot && lot.annexes && Object.values(lot.annexes).length" v-for="(a, i) in lot.annexes" :key="'annexes' + i">
            <b v-if="!a.is_parking">{{ a.annex_type | annexTypeLabel | cap }}</b>
            <b v-else-if="a.is_parking">Parking</b>&nbsp;
            <span v-if="a.is_parking">{{ a.annex_type | cap }}</span>
            <span v-if="a.is_parking && (a.surface || a.info)">(</span>
            <span v-if="a.surface">{{ a.surface | prettyPrice}} m2</span>
            <span v-if="a.info">{{ a.info }}</span>
            <span v-if="a.is_parking && (a.surface || a.info)">)</span>
          </div>
          <div v-else>
            <i>Pas d'annexe renseignée</i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DefaultValues, DownloadFile, AdvMx } from '@/mixins'
  
  export default {
    name: 'AdvLot',
    mixins: [DefaultValues, DownloadFile, AdvMx],
    props: {
      lot: {
        type: Object,
        default: {}
      },
      program: {
        type: Object,
        default: {}
      },
      classes: {
        type: String
      },
      displayButton: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      taxDispositifs () {
        if (this.lot && this.lot.tax_dispositifs && this.lot.tax_dispositifs.length) {
          return this.lot.tax_dispositifs.map(x => this.taxDispositifsData[x].label).join(', ')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/Details/AdvLotCompact.vue